import React, { useState } from "react";
import { parsal_img } from "../assets/mediaCall";
import { Link } from "react-router-dom";

const Navbar = () => {
  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);
  const toggleMenu = () => {
    setMobileMenuOpen(true);
  };

  const closeMenu = () => {
    setMobileMenuOpen(false);
  };

  return (
    <nav className=" z-20 w-[85vw] mlg:w-[90vw] smp:w-[96vw] mx-auto inter">
      <div className="">
        <div className="flex items-center justify-between h-20 smp:h-[72px]">
          {/* Left side */}
          <div className="flex justify-center items-center gap-4 smp:gap-2">
            {/* Hamburger Menu */}
            <button
              className="hidden w-[30px] h-[30px] p-1 lg:flex justify-center items-center mr-2"
              onClick={toggleMenu}
            >
              <img src={parsal_img.burger} alt="" />
            </button>

            {/* Logo */}
            <Link to="/">
              <div className="flex-shrink-0">
                <img
                  className="h-12 mlg:h-10 xs:h-8 w-auto"
                  src={parsal_img.logo}
                  alt="Parsal Logo"
                />
              </div>
            </Link>
          </div>
          {/* Links */}
          <div className="lg:hidden flex justify-center items-center ml-10 z-10 text-[17px] xl:text-[16px] list-none">
            <Link to="/">
              <li
                // href="/"
                className="text-[var(--clr-grey-1)] hover:text-[var(--clr-blue-1)] px-3 xl:px-2.5 mlg:px-2 py-2 rounded-md  inter font-medium cursor-pointer"
              >
                Home
              </li>
            </Link>
            <li
              // href="/about"
              className="text-[var(--clr-grey-1)] hover:text-[var(--clr-blue-1)] px-3 xl:px-2.5 mlg:px-2 py-2 rounded-md inter font-medium cursor-pointer"
            >
              About
            </li>
            <li
              // href="/services"
              className="text-[var(--clr-grey-1)] hover:text-[var(--clr-blue-1)] px-3 xl:px-2.5 mlg:px-2 py-2 rounded-md inter font-medium cursor-pointer"
            >
              Services
            </li>
            <li
              // href="/shipment"
              className="text-[var(--clr-grey-1)] hover:text-[var(--clr-blue-1)] px-3 xl:px-2.5 mlg:px-2 py-2 rounded-md inter font-medium cursor-pointer"
            >
              Shipment
            </li>
            <li
              // href="/pricing"
              className="text-[var(--clr-grey-1)] hover:text-[var(--clr-blue-1)] px-3 xl:px-2.5 mlg:px-2 py-2 rounded-md inter font-medium cursor-pointer"
            >
              Pricing
            </li>
            <li
              // href="/contact"
              className="text-[var(--clr-grey-1)] hover:text-[var(--clr-blue-1)] px-3 xl:px-2.5 mlg:px-2 py-2 rounded-md inter font-medium cursor-pointer"
            >
              Contact Us
            </li>
          </div>

          {isMobileMenuOpen && (
            <div className=" w-full h-screen top-0 left-0 fixed flex flex-col bg-white z-50">
              <div className="h-20 smp:h-[72px] flex items-center justify-between w-[94vw] smp:w-[96vw] mx-auto">
                <Link to="/">
                  <div className="flex-shrink-0">
                    <img
                      className="h-10 xs:h-8 w-auto"
                      src={parsal_img.logo}
                      alt="Parsal Logo"
                    />
                  </div>
                </Link>
                {/* Close button */}
                <button
                  className=" w-[34px] h-[34px] p-1 flex justify-center items-center"
                  onClick={closeMenu}
                >
                  <img src={parsal_img.close} alt="Close Menu" />
                </button>
              </div>

              <div className="top-20 smp:top-[72px] left-0 fixed flex flex-col w-full inter font-semibold text-[16px] xs:text-[14px] leading-[16.52px] list-none">
                {/* <div></div>
                 */}
                <Link to="/">
                  <li
                    // href="/"
                    className="text-[var(--clr-grey-1)] hover:text-[var(--clr-blue-1)] py-[14px] pl-[28px]  smp:pl-[10px] border-y"
                    onClick={closeMenu}
                  >
                    {/* <img
                    src={parsal_img.home}
                    className="h-5 w-5 object-contain mr-1"
                  /> */}
                    Home
                  </li>
                </Link>

                <li
                  // href="/about"
                  className="text-[var(--clr-grey-1)]  hover:text-[var(--clr-blue-1)] py-[14px] pl-[28px]  smp:pl-[10px] border-b"
                  onClick={closeMenu}
                >
                  {/* <img
                    src={parsal_img.about}
                    className="h-4 w-4 object-contain mr-1"
                  /> */}
                  About
                </li>

                <li
                  // href="/services"
                  className="text-[var(--clr-grey-1)]  hover:text-[var(--clr-blue-1)] py-[14px] pl-[28px] smp:pl-[10px] border-b"
                  onClick={closeMenu}
                >
                  {/* <img
                    src={parsal_img.delivery}
                    className="h-4 w-4 object-contain mr-1"
                  /> */}
                  Services
                </li>

                <li
                  // href="/shipment"
                  className="text-[var(--clr-grey-1)]  hover:text-[var(--clr-blue-1)] py-[14px] pl-[28px] smp:pl-[10px] border-b"
                  onClick={closeMenu}
                >
                  {/* <img
                    src={parsal_img.delivery}
                    className="h-4 w-4 object-contain mr-1"
                  /> */}
                  Shipment
                </li>

                <li
                  // href="/pricing"
                  className="text-[var(--clr-grey-1)]  hover:text-[var(--clr-blue-1)] py-[14px] pl-[28px] smp:pl-[10px] border-b"
                  onClick={closeMenu}
                >
                  {/* <img
                    src={parsal_img.rupee}
                    className="h-4 w-4 object-contain mr-1"
                  /> */}
                  Pricing
                </li>

                <li
                  // href="/contact"
                  className="text-[var(--clr-grey-1)] hover:text-[var(--clr-blue-1)] py-[14px] pl-[28px] smp:pl-[10px] border-b"
                  onClick={closeMenu}
                >
                  {/* <img
                    src={parsal_img.headset}
                    className="h-4 w-4 object-contain mr-1"
                  /> */}
                  Contact Us
                </li>
              </div>
            </div>
          )}
          {/* Right side */}
          <button className="flex items-center sm:hidden">
            <div
              // href="/download"
              className="bg-black text-[var(--clr-white-1)]  font-bold rounded-[10px] py-1.5 sm:py-1 pl-2 pr-2 mlg:pr-1 text-sm sm:text-xs flex items-center"
            >
              <div>Download the App</div>
              <div>
                <img
                  src={parsal_img.arrow_down} // Replace with the actual path to your icon image
                  alt="App Icon"
                  className="ml-1 mlg:ml-0" // Add margin to separate the icon from the text
                />
              </div>
            </div>
          </button>
        </div>
      </div>
    </nav>
  );
};
export default Navbar;
